import React from 'react';
import { Shield } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center mb-4">
              <Shield className="h-6 w-6 text-indigo-600" />
              <span className="ml-2 text-lg font-bold text-white">CoverBids</span>
            </div>
            <p className="text-sm text-gray-400">
              Where insurers compete for your business
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-white">Products</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/car-insurance" className="hover:text-white">Car Insurance</a></li>
              {/*<li><a href="/home-insurance" className="hover:text-white">Home Insurance</a></li>
              <li><a href="/life-insurance" className="hover:text-white">Life Insurance</a></li>
              <li><a href="/mortgage" className="hover:text-white">Mortgages</a></li>*/}
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-white">Company</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/about" className="hover:text-white">About Us</a></li>
              <li><a href="/how-it-works" className="hover:text-white">How It Works</a></li>
              <li><a href="/register-insurer" className="hover:text-white">For Insurers</a></li>
              <li><a href="/contact" className="hover:text-white">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-white">Legal</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/terms" className="hover:text-white">Terms & Conditions</a></li>
              <li><a href="/privacy" className="hover:text-white">Privacy Policy</a></li>
              <li><a href="/cookies" className="hover:text-white">Cookie Policy</a></li>
              <li><a href="/complaints" className="hover:text-white">Complaints</a></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8">
          <div className="prose prose-sm max-w-none text-gray-400 text-xs">
            <p className="mb-4">
              CoverBids.com is operated by Broconus Ltd and acts solely as an insurance intermediary, 
              facilitating a bidding platform where insurers can provide quotes to customers. Broconus Ltd 
              is not authorised or regulated by the Financial Conduct Authority (FCA) and does not provide 
              financial or insurance advice. No advice is given or implied, and it is the sole responsibility 
              of the customer to assess and select the most suitable insurance policy for their needs.
            </p>
            <p className="mb-4">
              All transactions on CoverBids.com are between the customer and the chosen insurer. 
              Broconus Ltd does not underwrite policies, guarantee coverage, or accept liability for 
              any insurer's terms, pricing, or service. Customers should carefully review policy details, 
              terms, and conditions before making a decision.
            </p>
            <p>
              By using CoverBids.com, you acknowledge and agree to these terms.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-xs text-gray-400">
          <p>
            © {new Date().getFullYear()} Broconus Ltd. All rights reserved.
            Registered in Northern ireland (Company No. NI726152)
          </p>
        </div>
      </div>
    </footer>
  );
}
